import api from "../axios";
import { type UserProfile } from "../types";

export class ApiAuth {
  loginWithTelegram(init_data: string) {
    return api.post<{ user_id: string }>(
      "/auth/webapp/login",
      { init_data },
      { withCredentials: true },
    );
  }

  getProfile() {
    return api.get<UserProfile>("/profile/me");
  }

  loginAsUser(userId: string) {
    return api.post("/auth/users/login", { user_id: userId });
  }
}
